"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuraPopover = void 0;
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const Icons_1 = require("./Icons");
require("../styles/eura-popover.css");
const typeClasses = {
    error: 'eura-popover__error',
};
const useStateRef = (processNode) => {
    const [node, setNode] = (0, react_1.useState)(null);
    const setRef = (0, react_1.useCallback)((newNode) => {
        setNode(processNode(newNode));
    }, [processNode]);
    return [node, setRef];
};
const ErrorContent = (props) => {
    const [clientHeight, setRef] = useStateRef((node) => (node === null || node === void 0 ? void 0 : node.clientHeight) || 0);
    (0, react_1.useEffect)(() => { }, [clientHeight]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: typeof clientHeight === 'number' && clientHeight <= 35
                ? 'eura-popover__error-icon-oneline-text'
                : 'eura-popover__error-icon-multiline-text' },
            react_1.default.createElement(Icons_1.TriangleErrorIcon, { width: '18px', height: '20px', fill: '#fbfbfb', background: '#e8102b' })),
        react_1.default.createElement("div", { ref: setRef, role: 'alert' }, props.children)));
};
const EuraErrorPopover = (props) => {
    const { content } = props, other = __rest(props, ["content"]);
    return (react_1.default.createElement(exports.EuraPopover, Object.assign({ content: react_1.default.createElement(ErrorContent, null, props.content), type: 'error' }, other), props.children));
};
/**
 * Wrapattu AntD:n Popover-komponentti.
 * Propsikuvaus: https://ant.design/components/popover/#API
 * Komponentti sisältää valmiin toteutuksen leiskan mukaiselle contentille.
 * Esimerkki valmiin contentin käytöstä:
 *
 *
 * <EuraPopover.ErrorPopover
 *   visible={true}
 *   content={<span>lalalaaa</span>}
 *   placement='top'
 *   align={{
 *     offset: [0, 0],
 *     targetOffset: [48, 20],
 *     overflow: { adjustX: true, adjustY: true },
 *   }}
 *  >
 *
 * @param props
 * @param props.type Popoverin visuaalinen tyyli.
 */
const EuraPopover = (props) => {
    var _a;
    const classConstruct = ['eura-popover', props.type ? typeClasses[props.type] : '', (_a = props.overlayClassName) !== null && _a !== void 0 ? _a : ''];
    return (react_1.default.createElement(antd_1.Popover, Object.assign({ overlayClassName: classConstruct.join(' ') }, props), props.children));
};
exports.EuraPopover = EuraPopover;
exports.EuraPopover.ErrorContent = ErrorContent;
exports.EuraPopover.ErrorPopover = EuraErrorPopover;
